import { DataTable, DataTableField } from "../../../../components/data/DataTable";
import Avatar from "../../../../components/base/Avatar";
import FlexRow from "../../../../components/base/FlexRow";
import WalletTransaction from "../../../../models/WalletTransaction";
import filtering from "../filtering/walletTransactions.json";
import sorting from "../sorting/walletTransactions.json";


const money = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
})

const prettyType = (t?: string) => {
    switch (t) {
        case "SMSCharge": return "SMS"
        case "CallsUsage": return "Calls"
        case "BuyLine": return "Buy Line"
        case "RenewLine": return "Renew Line"
        case "MonthlySubscription": return "Subscription"
        case "ExtraSeats": return "Extra Seats"
        case "Invoice": return "Invoice"
        case "InitialCharge": return "Initial Charge"
        case "ChargeWallet": return "Wallet Charge"
        default: return t ?? "-"
    }
}

const TypeCol = (data: WalletTransaction) => (
    <span className={`badge ${data.deposit ? "badge-light-success" : "badge-light-primary"} fs-7`}>
        {prettyType(data.type)}
    </span>
)

const AmountCol = (data: WalletTransaction) => (
    <span className={`fs-6 fw-bold ${data.deposit ? "text-success" : "text-danger"}`}>
        {data.deposit ? "+" : "-"} {data.amountText ?? money.format(data.amount)}
    </span>
)

const DescCol = (data: WalletTransaction) => (
    <span className="fs-7 text-gray-700">{data.description || "-"}</span>
)

// System/automatic entries have no performer — attribute those to the Rinvox bot.
const ByCol = (data: WalletTransaction) => {
    const name = data.performedByUser?.fullName ?? "Rinvox Bot"
    return (
        <FlexRow>
            <Avatar avatarUrl={data.performedByUser?.avatarUrl} fullName={name} width={22} />
            <span className="fs-8 text-gray-700 ms-2">{name}</span>
        </FlexRow>
    )
}

const DateCol = (data: WalletTransaction) => (
    <span className="fs-8 text-gray-600">{data.shortDate}</span>
)


// Read-only wallet transactions table (usages + top-ups combined) backed by the shared DataTable,
// with direction + type filtering and keyword search.
export default function WalletTransactionsTable() {

    return (
        <div className="wallet-transactions">
            <DataTable
                objectName="Transaction"
                apiRoute="/accounts/profile/wallet/transactions/list/"
                filteringProps={filtering}
                sortingProps={sorting}
                preventCreate
                preventLinkUpdate
                noAction
                noMultipleActions>

                <DataTableField title="Type">
                    <TypeCol />
                </DataTableField>

                <DataTableField title="Amount">
                    <AmountCol />
                </DataTableField>

                <DataTableField title="Description">
                    <DescCol />
                </DataTableField>

                <DataTableField title="By">
                    <ByCol />
                </DataTableField>

                <DataTableField title="Date">
                    <DateCol />
                </DataTableField>

            </DataTable>
        </div>
    )
}
